import { render, staticRenderFns } from "./ClinicForm.vue?vue&type=template&id=a8bcf24e&scoped=true"
import script from "./ClinicForm.vue?vue&type=script&lang=js"
export * from "./ClinicForm.vue?vue&type=script&lang=js"
import style0 from "./ClinicForm.vue?vue&type=style&index=0&id=a8bcf24e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bcf24e",
  null
  
)

export default component.exports